import React from "react"
import * as S from "./elements"

export type Variant = "full-width" | "wide" | "square"

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  variant: Variant
}

const Image: React.FC<Props> = ({ variant, ...rest }) => {
  return (
    <S.Container variant={variant}>
      <S.Image {...rest} />
    </S.Container>
  )
}

export default Image
